import moment from 'moment-timezone';
import createSelector from 'web-app/util/custom-create-selector';
import RoutesMap from 'signin-app/routes/routes-map';
import * as GroupsSelectors from 'signin-app/groups/selectors';
import { signInAppBehaviorIds as SignInAppBehaviorIds } from '@famly/vet_signin-app-behavior-ids';
import { isPinApp } from 'signin-app/login/selectors';
import * as PinSelectors from 'signin-app/pin/selectors';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { makeChildSelector, relations, getPinChild } from '../selectors';
const entityChildSelector = makeChildSelector(RoutesMap.childCheckOut);
export const getChild = createSelector(isPinApp, getPinChild, entityChildSelector, (pinApp, pinChild, entityChild) => {
    if (pinApp) {
        return pinChild;
    }
    return entityChild;
});
export const isCheckingOut = (state) => state.childCheckOut.isCheckingOut;
export const pickupName = createSelector((_, props) => props.child && props.child.pickupRelationId, relations, (pickupRelationId, relations) => {
    const pickupPerson = relations.find(relation => relation.relationId === pickupRelationId);
    return pickupPerson ? pickupPerson.name : null;
});
export const pickupFullName = createSelector(pickupName, isPinApp, PinSelectors.goHomeWithChild, (name, pinApp, goHomeWithChild) => {
    var _a;
    if (pinApp && goHomeWithChild) {
        return goHomeWithChild.name.fullName;
    }
    else if (pinApp && name) {
        return name.firstName;
    }
    else {
        return (_a = name === null || name === void 0 ? void 0 : name.fullName) !== null && _a !== void 0 ? _a : null;
    }
});
export const pickupImage = createSelector((_, props) => props.child && props.child.pickupRelationId, relations, (pickupRelationId, relations) => {
    const pickupPerson = relations.find(relation => relation.relationId === pickupRelationId);
    return pickupPerson === null || pickupPerson === void 0 ? void 0 : pickupPerson.image.small;
});
export const pickupTime = createSelector((_, props) => props.child, GroupsSelectors.timezone, (child, timezone) => {
    if (hasValue(child) && hasValue(child.pickupTime)) {
        return moment.tz(child.pickupTime, timezone).format('LT');
    }
    return null;
});
export const pickupFirstName = createSelector(pickupName, name => (name ? name.firstName : ''));
export const canSwitchRoom = createSelector(GroupsSelectors.institutionFeatures, isPinApp, (features, isPinApp) => !isPinApp && features.includes(SignInAppBehaviorIds.childrenSwitchRoom));
export const limitedData = createSelector(GroupsSelectors.institutionFeatures, features => features.includes(SignInAppBehaviorIds.limitedData));
